module.exports = __webpack_public_path__ + "static/media/8OLA21.cf6c5320.jpg";